import { DownOutlined, ExportOutlined } from "@ant-design/icons";
import { Button, Modal, Spin } from "antd";
import { ReactNode } from "react";

interface PropsExportBtn {
    onClick?: () => void;
    onClose?: () => void;
    disabled?: boolean;
    loading?: boolean;
    isDropdown?: boolean;
    open?: boolean;
    block?: boolean;
    items?: ReactNode;
}

export default function ExportBtn({
    onClick,
    onClose,
    disabled = false,
    loading = false,
    isDropdown,
    open,
    block = false,
    items
}: PropsExportBtn) {
    return (
        <>{isDropdown
            ? <>
                <Button
                    type="link"
                    className="show_result_size"
                    style={{ paddingRight: 24, marginBottom: 18 }}
                    disabled={disabled}
                    block={block}
                    onClick={onClick}>
                    Exportar <DownOutlined /></Button>
                <Modal
                    title="Exportar dados"
                    open={open}
                    maskClosable={true}
                    closeIcon={true}
                    footer={null}
                    width={582}
                    style={{ top: 20 }}
                    bodyStyle={{ padding: '12px 8px' }}
                    onCancel={onClose}>

                    <Spin spinning={loading}>
                        {items}
                    </Spin>
                </Modal>
            </>
            : <Button
                type="link"
                className="show_result_size"
                style={{ paddingRight: 24 }}
                onClick={onClick}
                disabled={disabled}
                loading={loading}
                block={block}>
                <ExportOutlined /> Exportar</Button>
        }</>
    )
}